import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CrownIcon, SearchXIcon, LockIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const icons = [<CrownIcon className="w-6 h-6" data-id="element-795" data-mp="2w9zpzur9fzg1" />, <SearchXIcon className="w-6 h-6" data-id="element-796" data-mp="2w9rf28ep747h" />, <LockIcon className="w-6 h-6" data-id="element-797" data-mp="2w8omlw1q8tpg" />, <GlobeIcon className="w-6 h-6" data-id="element-798" data-mp="3ayngvnq5vkzn" />];
const styles = [{
  bg: 'from-primary-100 to-primary-50',
  color: 'text-primary-600'
}, {
  bg: 'from-amber-100 to-amber-50',
  color: 'text-amber-600'
}, {
  bg: 'from-violet-100 to-violet-50',
  color: 'text-violet-600'
}, {
  bg: 'from-emerald-100 to-emerald-50',
  color: 'text-emerald-600'
}];
export function ClassicScenarios() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="relative py-20 lg:py-28 bg-navy-50/50 overflow-hidden" data-id="element-799" data-mp="1koaspueji9p1">
      <div className="absolute inset-0 pointer-events-none" data-id="element-800" data-mp="1pn6flj38u0rt">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-primary-100/20 blur-3xl hidden sm:block" data-id="element-801" data-mp="1ukoqvg4qgs2z" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-802" data-mp="1zj9k2vlkibhx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14 lg:mb-16" data-id="element-803" data-mp="24cb0j81faj3m">
          <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-804" data-mp="2ddiwhjggv7uj">
            {lang === 'EN' ? 'When you need us' : 'Коли ми потрібні'}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight max-w-4xl mx-auto" data-id="element-805" data-mp="2n93uz7mbtpzj">
            {c.scenarios.title}
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5 lg:gap-6" data-id="element-806" data-mp="sw4k1rsw5jyl">
          {c.scenarios.items.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + i * 0.08
        }} className="flex gap-4 sm:gap-5 p-6 lg:p-7 rounded-2xl bg-white border border-navy-200 shadow-sm" data-id="element-807" data-mp="kv5b1xz9kqyl" data-mpi={i}>
              <div className={`flex-shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br ${styles[i].bg} ${styles[i].color}`} data-id="element-808" data-mp="13szezxljcca4">
                {icons[i]}
              </div>
              <div data-id="element-809" data-mp="1disqkylogred">
                <div className="flex items-baseline gap-2.5" data-id="element-810" data-mp="1dley4y8kj6wl">
                  <span className="text-xs font-bold tabular-nums text-primary-500" data-id="element-811" data-mp="18lsiki59pekm">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="text-lg font-bold text-navy-900 leading-snug" data-id="element-812" data-mp="1ij70km6uabf1">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-2.5 text-[0.9375rem] text-navy-500 leading-relaxed" data-id="element-813" data-mp="217r07p7acvxm">
                  {item.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}